import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "replenish-dialog-content" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "table" }
const _hoisted_4 = { style: {} }
const _hoisted_5 = { class: "submit-btn" }

import { t } from '@/plugins/i18n'
import { ref, onMounted, watch, nextTick } from 'vue'
import { request } from '@/config/request/interceptors'
import { TransferInboundQuerySkuListResp } from '@/service/overseas'
import { countryCodeNameMap } from '@/common/const'
import { ElMessage } from 'element-plus'

export default /*#__PURE__*/_defineComponent({
  emits: ['addGoods'],
  setup(__props, { expose, emit }) {


const dialogVisible = ref(false)
const tableRef = ref()
const productSku = ref('')
const pageQuery = ref({
  total: 0,
  pageSize: 30,
  pageNum: 1,
  productSku: ''
})
const _paginationConfig = ref({
  total: 0,
  current: 1,
  pageSize: 30,
  pageSizes: [10, 20, 30, 50],
  layout: ' prev, pager, next, sizes, jumper ',
  background: true
})
const multipleSelection = ref<any[]>([])
const dataList = ref<TransferInboundQuerySkuListResp[]>([])
const handleSelectionChange = (val: any) => {
  multipleSelection.value = val
}

watch([() => pageQuery.value.pageNum, () => pageQuery.value.pageSize], (newValue, oldValue) => {
  console.log(newValue);
  if (newValue[1] !== oldValue[1]) {
    pageQuery.value.pageNum = 1
  }
  getList()
}, {
  deep: true
})

const submit = (clear = false) => {
  pageQuery.value.pageNum = 1
  pageQuery.value.pageSize = 30
  pageQuery.value.productSku = clear ? '' : productSku.value
  if (clear) {
    productSku.value = ''
  }
  getList()
}

const getList = async () => {
  const res = await request.overseas.overseasWms.transferInboundQuerySkuList({
    productSku: pageQuery.value.productSku,
    pageSize: pageQuery.value.pageSize,
    pageNum: pageQuery.value.pageNum
  })
  dataList.value = res.data?.records ?? []
  pageQuery.value.total = res.data?.total ?? 0
  // 关键：重新计算表格布局
  nextTick(() => {
    tableRef.value?.doLayout();
  });
}

const hanleAddGoods = () => {
  if (!multipleSelection.value.length) return ElMessage.warning(t('请选择商品'))
  emit('addGoods', multipleSelection.value)
  dialogVisible.value = false
}

expose({
  show: () => {
    dialogVisible.value = true
    getList()
  }
})


return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((dialogVisible).value = $event)),
    width: "500",
    "custom-class": "addProduct-dialog"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('商品を追加')), 1)
        ]),
        _createVNode(_component_el_divider),
        _createElementVNode("div", null, [
          _createVNode(_component_el_form, {
            inline: "",
            "label-width": "0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    placeholder: "商品コード",
                    modelValue: productSku.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((productSku).value = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (submit(false)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('搜索')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (submit(true)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('重置')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_table, {
            data: dataList.value,
            style: {"width":"100%"},
            height: "400px",
            ref: (_value, _refs) => {
              _refs['tableRef'] = _value
              tableRef.value = _value
            },
            onSelectionChange: handleSelectionChange
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                type: "selection",
                width: "55"
              }),
              _createVNode(_component_el_table_column, {
                prop: "productSku",
                label: _unref(t)('商品コード')
              }, null, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                prop: "productName",
                label: _unref(t)('商品名')
              }, null, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                prop: "purchaseCountry",
                label: _unref(t)('仕入れ元国')
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(_unref(countryCodeNameMap).get(row.purchaseCountry)), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                prop: "price",
                label: _unref(t)('単価')
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(row.price) + "円 （税込） ", 1)
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }, 8, ["data"]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_pagination, _mergeProps(_paginationConfig.value, {
              total: pageQuery.value.total,
              pageSize: pageQuery.value.pageSize,
              "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((pageQuery.value.pageSize) = $event)),
              currentPage: pageQuery.value.pageNum,
              "onUpdate:currentPage": _cache[4] || (_cache[4] = ($event: any) => ((pageQuery.value.pageNum) = $event)),
              style: {"justify-content":"flex-end","margin-top":"20px"}
            }), null, 16, ["total", "pageSize", "currentPage"])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_button, {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (dialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            onClick: hanleAddGoods,
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('确定')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})